import { ShareModal } from '@/components/sharing';
import type { StructuredFeedbackData } from '@/lib/reasoning/feedback';

import { FeedbackModal } from './FeedbackModal';

interface ConversationModalsProps {
  orgId: string;
  conversationId: string | undefined;
  conversationTitle: string | undefined;
  isShareModalOpen: boolean;
  onCloseShareModal: () => void;
  feedbackModalChainId: string | null;
  feedbackModalOpen: boolean;
  feedbackModalSteps: Array<{ id: number; step_number: number }>;
  onFeedbackModalClose: () => void;
  onFeedbackSubmit: (data: StructuredFeedbackData) => Promise<void>;
}

/** Standalone modals/overlays for the conversation page: share + feedback. */
export function ConversationModals({
  orgId,
  conversationId,
  conversationTitle,
  isShareModalOpen,
  onCloseShareModal,
  feedbackModalChainId,
  feedbackModalOpen,
  feedbackModalSteps,
  onFeedbackModalClose,
  onFeedbackSubmit,
}: ConversationModalsProps) {
  return (
    <>
      {conversationId && (
        <ShareModal
          isOpen={isShareModalOpen}
          onClose={onCloseShareModal}
          orgId={parseInt(orgId)}
          objectType='conversation'
          objectId={parseInt(conversationId)}
          objectTitle={conversationTitle || 'Conversation'}
          isCreator={true}
        />
      )}

      {feedbackModalChainId && orgId && (
        <FeedbackModal
          isOpen={feedbackModalOpen}
          onClose={onFeedbackModalClose}
          onSubmit={onFeedbackSubmit}
          chainId={parseInt(feedbackModalChainId)}
          orgId={parseInt(orgId)}
          steps={feedbackModalSteps}
        />
      )}
    </>
  );
}
